export const environment = {
  production: true,
  environmentName: 'prod',
  //identityServer: "https://www.aramex.net/apps/OutletIdentity/authorize?return={{enviroment}}/dashboard/s/{0}"
  identityServer: "https://ws.aramex.net/OutletLogin?returnUrl={{enviroment}}/dashboard/s/{token}",
  identityLogOut: "https://ws.aramex.net/identity/api/logout",
  DGSecure: "https://mdm.digitsecure.com/plugin/dgpay.invoke.js"
};
